<!--
 * @Description: 自开票据
 * @Author: luzx
 * @Date: 2023-08-02 9:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-04-28 14:31:09
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="header_right" @click="showCardNav = !showCardNav">
        <div class="title">搜索</div>
        <div>
          <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div v-show="showCardNav" class="hr"></div>
      <el-collapse-transition>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">票据类型：</span>
              <el-select v-model="tableParam.billType" style="width: 200px" clearable placeholder="请选择">
                <el-option v-for="(item, index) in piaojuList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
                <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">出票日期：</span>
                <el-date-picker v-model="searchTime1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange1"> </el-date-picker>
              </span>
              <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
                <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">到期日期：</span>
                <el-date-picker v-model="searchTime2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange2"> </el-date-picker>
              </span>
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">票号:</span>
              <el-input v-model="tableParam.billNumber" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">所属主体:</span>
              <el-input v-model="tableParam.subjectCompany" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">收款人户名:</span>
              <el-input v-model="tableParam.receiver" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">授信银行:</span>
              <el-select ref="shoukuanandmonList" v-model="tableParam.authBankId" filterable style="width: 200px" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 80px; text-align: right">付款方式:</span>
              <el-select v-model="tableParam.paymentMethodId" filterable style="width: 200px" placeholder="请选择" clearable>
                <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </span>

            <span style="display: inline-block; margin-bottom: 10px">
              <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableDataex()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </span>
          </div>
        </div>
      </el-collapse-transition>
      <div class="hr"></div>
      <el-main style="display: flex">
        <div>
          <!-- <div class="card scroll"> -->
          <div class="card">
            <div class="card_nav">
              <div style="display: flex; align-items: center">
                <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addcard"> 添加 </el-button>
                <el-button size="small" class="bottom_one" style="margin-left: 10px" @click="exportDialog = true"> 导入 </el-button>
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHANCHU') !== -1" size="small" class="bottom_two" @click="delHandler"> 删除 </el-button>
                <div style="margin-left: 10px; color: red; font-weight: bold"><span style="">合计金额：</span>{{ tableData[0] ? (tableData[0].totalMoney ? numFormat(tableData[0].totalMoney) : 0) : 0 }} 元</div>
              </div>
              <div>
                <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="load()">导 出</el-button>
              </div>
            </div>
            <!-- { background: '#f3f6f9' } -->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未开票</span>
                        <span v-if="scope.row.dataStatus == 1" style="color: #00a754">已开票</span>
                      </span>
                      <span v-else-if="item.label == '集团内'">
                        <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
                        <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
                      </span>
                      <span v-else-if="item.label == '票面金额'">
                        <span  >{{numFormat(scope.row.billMoney)}}</span>
                      </span>
                      <span v-else-if="item.label == '流程'">
                        <span v-if="scope.row.flowPath == 0" style="color: #969799">流程未走完</span>
                        <span v-if="scope.row.flowPath == 1" style="color: #00a754">流程已走完</span>
                      </span>
                      <span v-else-if="item.label == '是否认领'">
                        <span style="color: #969799">{{ ["流水待认领", "流水未认领完", "流水已认领，流程中", "流水已认领", "已完结"][scope.row.claimStatus] }}</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1" class="bottom_one" size="mini" @click="lookcard(scope.row)"> 修改 </el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableDataex()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableDataex">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- <diaLog1 :dialog="dialog1" :low="low" @reset="reset" @submit="submit"></diaLog1> -->
    <el-dialog :title="titleName" :visible.sync="dialog" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="formDate" :rules="rules" :model="formDate" :inline="true" label-width="160px">
          <!-- <el-form-item label="月份：" prop="collectMoneyMouth">
            <el-date-picker v-model="formDate.collectMoneyMouth" type="month" style="width: 300px" value-format="yyyy-MM"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="日期：" prop="collectMoneyData">
            <el-date-picker v-model="formDate.collectMoneyData" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="付款方式：" prop="paymentMethodId">
            <el-select
              ref="paymentMethodId"
              v-model="formDate.paymentMethodId"
              style="width: 300px"
              placeholder="请选择"
              filterable
              @change="
                changestatus(),
                  $nextTick(() => {
                    formDate.paymentMethod = $refs.paymentMethodId.selectedLabel;
                  })
              "
            >
              <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票据类型：" prop="billType">
            <el-select
              ref="billType"
              v-model="formDate.billType"
              style="width: 300px"
              placeholder="请选择"
              @change="
                changestatus(),
                  $nextTick(() => {
                    formDate.billTypeName = $refs.billType.selectedLabel;
                  })
              "
            >
              <el-option v-for="(item, index) in piaojuList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票号：" prop="billNumber">
            <el-input v-model="formDate.billNumber" style="width: 300px" clearable placeholder="请输入" @blur="formDate.billNumber=$regExp.enableSpace(formDate.billNumber)" />
          </el-form-item>
          <el-form-item label="票面金额：" prop="billMoney">
            <el-input v-model="formDate.billMoney" style="width: 300px" clearable placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="授信银行：" prop="authBankId">
            <el-select
              ref="shoukuanandmonList"
              v-model="formDate.authBankId"
              filterable
              style="width: 300px"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.authBank = $refs.shoukuanandmonList.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属主体：" prop="subjectCompanyId">
            <el-select ref="collaborativeAgent" v-model="formDate.subjectCompanyId" style="width: 300px" filterable placeholder="请选择" @change="subjectCompanyChange()">
              <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承兑人名称：" prop="acceptor">
            <el-input v-model="formDate.acceptor" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="出票人户名：" prop="drawer">
            <el-input v-model="formDate.drawer" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="收款人户名：" prop="receiverId">
            <el-select
              ref="collaborativeAgent"
              v-model="formDate.receiverId"
              style="width: 300px"
              filterable
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.receiver = $refs.collaborativeAgent.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出票日期：" prop="issueDate">
            <el-date-picker v-model="formDate.issueDate" type="date" style="width: 300px" value-format="yyyy-MM-dd" placeholder="选择日期" @change="changeIssueDate"> </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期：" prop="dueDate">
            <el-date-picker v-model="formDate.dueDate" type="date" style="width: 300px" value-format="yyyy-MM-dd" placeholder="选择日期" @change="changeDueDate"> </el-date-picker>
          </el-form-item>
          <el-form-item label="票据期限：" prop="limitTime">
            <el-input v-model="formDate.limitTime" style="width: 300px" disabled clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="到期天数：" prop="dueDays">
            <el-input v-model="formDate.dueDays" style="width: 300px" disabled clearable placeholder="">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="批次：" prop="batchNumber">
            <el-input v-model="formDate.batchNumber" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注1：">
            <el-input v-model="formDate.remark1" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注2：">
            <el-input v-model="formDate.remark2" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注3：">
            <el-input v-model="formDate.remark3" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注4：">
            <el-input v-model="formDate.remark4" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="addcardSure('formDate')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="付款单位管理" :visible.sync="dialog1" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="low" label-width="140px">
          <el-form-item label="付款单位:">
            <el-input v-model="payerUnitParams.payerUntiName" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                payerUnitParams.page = 1;
                getpayerUnitManage();
              "
              >查 询</el-button
            >
            <el-button type="primary" @click="dialog2 = true">添 加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tablepayerUnit" tooltip-effect="dark">
        <el-table-column label="付款单位" align="center" width="auto">
          <template slot-scope="scope">
            <span>{{ scope.row.payerUntiName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="集团内" align="center" width="auto">
          <template slot-scope="scope">
            <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
            <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="auto">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="
                dialog2 = true;
                addPayerUnit = scope.row;
              "
            >
              <i class="icon iconfont" style="font-size: 12px"></i>
              修改
            </el-button>
            <el-button size="mini" class="bottom_two" @click="delPayerUnit(scope.row)">
              <i class="icon iconfont" style="font-size: 12px"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ totalpayerUnit }}条</div>
          <el-pagination :current-page.sync="payerUnitParams.page" layout="prev,pager,sizes,next,jumper" :total="totalpayerUnit" @current-change="getpayerUnitManage()"></el-pagination>
        </div>
        <div>
          <!-- <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                      @click="gettableDataex">刷新</el-button> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="dialog1 = false">确 定</el-button> -->
      </span>
    </el-dialog>

    <!-- 添加付款单位 -->
    <el-dialog title="添加/修改" :visible.sync="dialog2" width="500px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="addPayerUnit" label-width="140px">
          <el-form-item label="付款单位:">
            <el-input v-model="addPayerUnit.payerUntiName" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="集团内：">
            <el-radio v-model="addPayerUnit.whetherGroup" :label="1">是</el-radio>
            <el-radio v-model="addPayerUnit.whetherGroup" :label="0">否</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialog2 = false;
            initaddPayer();
          "
          >关 闭</el-button
        >
        <el-button type="primary" @click="addPayerUnitSure">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 导入 -->
     <el-dialog v-dialogDrag :visible.sync="exportDialog" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导入自开票据</span>
      <div v-loading="loading" element-loading-text="数据解析中..." element-loading-background="rgba(0, 0, 0, 0.8)" class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag action="/icps/system/sign/dataCollection/payment/importList" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
        </el-upload>
        <div style="padding-top: 10px">
          <el-button class="bottom_all" style="margin-left: 0" @click="importSubmit()">下载模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 销售确认 -->
    <el-dialog title="销售确认" :visible.sync="dialog3" width="500px" :close-on-click-modal="false">
      <div>请确认需要接收收款确认短信的人员:</div>
      <div style="margin-top: 20px">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="low" label-width="80px">
          <el-form-item label="发送对象:">
            <el-cascader
              ref="cascader"
              v-model="userList"
              :options="treeArry"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name', children: 'children', multiple: true }"
              filterable
              @change="userChooseChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addsallerList">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="boxSaller">
        <div v-for="(item, index) in sallerList" :key="index" class="sallerItem">
          <div>{{ item.saller }} <i class="el-icon-close" style="cursor: pointer" @click="delItem(index)"></i></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog3 = false">关 闭</el-button>
        <el-button type="primary" @click="sendSrueSaller">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 认领 -->
    <el-dialog title="认领" :visible.sync="dialog4" width="1200px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="140px">
          <el-form-item label="收款（元）:">
            <el-input v-model="formDate.collectMoney" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="已认领（元）:">
            <el-input v-model="formDate.claimMoney" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="付款单位:">
            <el-input v-model="formDate.payUnit" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="收款单位">
            <el-input v-model="formDate.collaborativeAgent" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" @click="addCollectClaim">添 加</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="collectClaimList" tooltip-effect="dark">
        <el-table-column label="工程名称" align="center" width="300">
          <template slot-scope="scope">
            <el-select v-model="scope.row.engineeringId" style="width: 280px" filterable placeholder="请选择" @change="changstatus(scope.$index, scope.row)">
              <el-option v-for="(item, index) in engineeringNameList" :key="index" :label="item.engineeringName" :value="item.engineeringId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="认领金额（元）" align="center" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.claimMoney" type="number" style="width: 100px" clearable placeholder="请输入" />
          </template>
        </el-table-column>
        <el-table-column label="流程" align="center" width="160">
          <template slot-scope="scope">
            <el-radio v-model="scope.row.flowPath" :label="1" style="margin-right: 0 !important">流程已走完</el-radio>
            <el-radio v-model="scope.row.flowPath" :label="0">流程未走完</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="合同签订主体" align="center" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.collaborationUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售员" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.saller" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.saller }}</span>
          </template>
        </el-table-column>
        <el-table-column label="处别" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.sallerDivision" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.sallerDivision }}</span>
          </template>
        </el-table-column>
        <el-table-column label="财务编码" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.financialCode" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.financialCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
              <i class="icon iconfont" style="font-size: 12px"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog4 = false">关 闭</el-button>
        <el-button type="primary" @click="addOtherSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { formatTreeData } from "@/utils/utils";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";
// import { getDicsType } from "@/api/common.js";
// import { getUserInfo } from "@/utils/auth"
import {
  queryPage,
  queryPage1,
  Download,
  get_list_by_type,
  queryInvoicedAmount,
  saveOrUpdate,
  saveOrUpdatecollectMoney,
  deletePayUnit,
  get_detail_code,
  deleteNotes,
  queryCollectClaimList,
  updateCollectMoneyClaim,
  queryDefaultSallers,
  sendMessionSaller,
} from "@/api/GHnumber/procurement.js";
import { post } from "@/api/table.js";
import { getToken, getUserId } from "@/utils/auth";
export default {
  mixins: [mixin],
  data() {
    return {
      exportDialog:false,
      loading: false,
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      queryPage1: queryPage1,
      DownloadURL: Download,
      batchUpdateOrDelete: deleteNotes,
      /*表格数据*/
      table: [
        { label: "付款方式", width: "120", prop: "paymentMethod", status: true },
        { label: "票据类型", width: "120", prop: "billTypeName", status: true },
        { label: "票号", width: "240", prop: "billNumber", status: true },
        { label: "票面金额", width: "120", prop: "billMoney", status: true },
        { label: "授信银行", width: "240", prop: "authBank", status: true },
        { label: "所属主体", width: "300", prop: "subjectCompany", status: true },
        { label: "承兑人名称", width: "120", prop: "acceptor", status: true },
        { label: "出票人户名", width: "240", prop: "drawer", status: true },
        { label: "收款人户名", width: "240", prop: "receiver", status: true },
        { label: "出票日期", width: "120", prop: "issueDate", status: true },
        { label: "到期日期", width: "120", prop: "dueDate", status: true },
        { label: "票据期限（月）", width: "140", prop: "limitTime", status: true },
        { label: "到期天数", width: "140", prop: "dueDays", status: true },
        { label: "批次", width: "140", prop: "batchNumber", status: true },
        { label: "备注1", width: "240", prop: "remark1", status: true },
        { label: "备注2", width: "240", prop: "remark2", status: true },
        { label: "备注3", width: "240", prop: "remark3", status: true },
        { label: "备注4", width: "240", prop: "remark4", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      dialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      disabled: false,
      modifyType: false,
      searchTime1: "",
      searchTime2: "",
      low: {},
      rules: {
        billType: [{ required: true, message: "请选择票据类型", trigger: "change" }],
        paymentMethodId: [{ required: true, message: "请选择付款方式", trigger: "change" }],
        billNumber: [{ required: true, message: "请输入票号", trigger: "change" }],
        billMoney: [{ required: true, message: "请输入票面金额", trigger: "change" }],
        authBankId: [{ required: true, message: "请选择授信银行", trigger: "change" }],
        subjectCompanyId: [{ required: true, message: "请选择所属主体", trigger: "change" }],
        acceptor: [{ required: true, message: "请输入承兑人名称", trigger: "change" }],
        drawer: [{ required: true, message: "请输入出票人户名", trigger: "change" }],
        receiverId: [{ required: true, message: "请选择收款人户名", trigger: "change" }],
        issueDate: [{ required: true, message: "请选择收出票日期", trigger: "change" }],
        dueDate: [{ required: true, message: "请选择到期日期", trigger: "change" }],
      },
      engineeringNameList: [], //工程名称列表
      invoicedAmount: "", //
      files: [],
      claimList: [
        { name: "流水待认领", id: 0 },
        { name: "流水未认领完", id: 1 },
        { name: "流水已认领，流程中", id: 2 },
        { name: "流水已认领", id: 3 },
        { name: "已完结", id: 4 },
      ], //是否认领列表
      mainList: [], //主体列表

      costMoneyInitData: [],
      payerUnitParams: {
        page: 1,
        pageSize: 10,
        payerUntiName: "",
      },
      totalpayerUnit: 0,
      tablepayerUnit: [],
      addPayerUnit: {
        payerUntiName: "",
        whetherGroup: 0,
      },
      payerUnitNoPage: [],
      formDate: {
        billType: "",
        billTypeName: "",
        billNumber: "",
        billMoney: "",
        authBankId: "",
        authBank: "",
        subjectCompany: "",
        subjectCompanyId: "",
        acceptor: "",
        drawer: "",
        receiverId: "",
        receiver: "",
        issueDate: new Date(),
        dueDate: "",
        limitTime: "",
        dueDays: "",
        batchNumber: "",
        remark1: "",
        remark2: "",
        remark3: "",
        remark4: "",
      },
      shoukuanList: [],
      shoukuanandmonList: [],
      shoukuanandmonList1: [],
      shoukuanandmonList2: [],
      piaojuList: [],
      recourseTransferList: [
        { name: "无追可转", id: "1" },
        { name: "无追不可转", id: "2" },
        { name: "可追可转", id: "3" },
        { name: "可追不可转", id: "4" },
      ],
      contractProcessList: ["合同已收", "流程已收"],
      collectionMethodList: [
        { name: "合同约定", id: "1" },
        { name: "流程审核", id: "2" },
      ],
      editFlag: false,
      options: [],
      isMust: true,
      titleName: "添加",
      collectClaimList: [], //认领列表
      renlingId: "",
      sallerList: [],
      treeArry: [],
      organizationList: [],
      userList: [],
      userNameList: [],
      sendFlag: true,
      loadingSaller: false,
      mainListBodys: [],
      supplierList: [],
    };
  },
  created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, billType: "", billNumber: "", subjectCompany: "", receiver: "", startTime: "", endTime: "", dueStartTime: "", dueEndTime: "", authBankId: "",paymentMethodId:"" };
    this.gettableDataex();
    this.get_list_by_type();
    this.get_detail_code();
    let params = {
      page: 1,
      pageSize: 99999,
      enable: 1,
    };
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
    });
  },
  mounted() {
    // if (this.ButtonList.findIndex(res => (res.buttonValue == 'XIUGAI')) == -1 && this.ButtonList.findIndex(res => (res.buttonValue == 'RENLING')) == -1) {
    //     this.table[33].status = false
    // } else {
    //     this.table[33].status = true
    // }
  },
  methods: {
    importSubmit(){
      window.open("https://lvshe.huashijc.com/file/group1/M00/0E/6E/ChQACmU6Ec6ABPM0AAAk5aD51gE15.xlsx");
    },
    /*导入数据*/
    filebefore(file) {
      console.log(file.type)
      this.loading = true;
      // const isJPG = file.type === "application/vnd.ms-excel";
      const isJPG = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isJPG) {
        this.$message.error("数据上传必须是 xlsx 格式!");
        this.loading = false;
      }
      return isJPG;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code == 1001) {
        this.$message.error(res.codeMsg);
        // this.$message({
        //   dangerouslyUseHTMLString: true,
        //   message: `本次导入数据成功！！！`,
        //   type: "success",
        // });
        this.exportDialog = false
        this.gettableDataex();
      } else {
        this.$message.error(res.codeMsg);
      }
    },
    changeIssueDate(e) {
      console.log(e);
      if (this.formDate.dueDate) {
        var beginDate = new Date(e);
        var endDate = new Date(this.formDate.dueDate);
        if (beginDate > endDate) {
          this.formDate.issueDate = "";
          this.formDate.limitTime = "";
          return this.$message.warning("请选择正确的出票时间！");
        }
        var days = Math.floor((endDate - beginDate) / (1000 * 60 * 60 * 24) / 30);
        console.log(days);
        this.formDate.limitTime = days;
      }
    },
    changeDueDate(e) {
      var endDate = new Date(e);
      var today = new Date();
      console.log(e);
      if (this.formDate.issueDate) {
        var beginDate = new Date(this.formDate.issueDate);
        if (beginDate > endDate) {
          this.formDate.dueDate = "";
          this.formDate.dueDays = "";
          this.formDate.limitTime = "";
          return this.$message.warning("请选择正确的到期时间！");
        }
        var days = Math.floor((endDate - beginDate) / (1000 * 60 * 60 * 24) / 30);
        this.formDate.limitTime = days;
      }
      var todaydays = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
      this.formDate.dueDays = todaydays;
    },
    subjectCompanyChange() {
      var arrChoose = this.mainList.filter(e => {
        if (e.id == this.formDate.subjectCompanyId) {
          return true;
        }
      });
      console.log(arrChoose);
      this.formDate.acceptor = arrChoose[0].name;
      this.formDate.drawer = arrChoose[0].name;
      this.formDate.subjectCompany = arrChoose[0].name;
    },
    dateChange1(e) {
      console.log(e);
      if (e) {
        this.tableParam.startTime = e[0];
        this.tableParam.endTime = e[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
    dateChange2(e) {
      console.log(e);
      if (e) {
        this.tableParam.dueStartTime = e[0];
        this.tableParam.dueEndTime = e[1];
      } else {
        this.tableParam.dueStartTime = "";
        this.tableParam.dueEndTime = "";
      }
    },
    numFormat(num) {
      var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    structuralPartsCheckFun() {
      // this.formDate.contractProcess = "";
      let item = this.contractProcessList.find(v => v.id == this.formDate.contractProcess);
      console.log(item);
      // if (item) {
      //     this.formDate.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
      //     if (item.performanceGrade) {
      //         this.formDate.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
      //     }
      //     if (item.meterialRequirements) {
      //         this.formDate.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
      //     }
      //     if (item.specialRequirements) {
      //         this.formDate.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
      //     }
      //     if (item.otherRequirements) {
      //         this.formDate.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
      //     }
      //     if (item.admixtureRequirements) {
      //         this.formDate.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
      //     }
      // }
    },
    /**
     * @Description: 获取所有组织和用户、格式化tree结构
     * @Param:
     * @Author: wangwangwang
     */
    initOrganization() {
      /* 
        把计算缓慢的数据暂时隐藏
      */
      // const { state } = this.$store;
      // if (!state.approvePerson.orgList || !state.approvePerson.userList) {
      //   console.log("---------user----------");
      //   const orgPromise = this.$store.dispatch("approvePerson/getorg");
      //   const userPromise = this.$store.dispatch("approvePerson/getuser");
      //   this.loading = true;
      //   Promise.all([orgPromise, userPromise])
      //     .then(([orgres, userres]) => {
      //       this.formatDataSource(orgres, userres);
      //     })
      //     .catch(e => console.log(e));
      // } else {
      //   this.formatDataSource(state.approvePerson.orgList, state.approvePerson.userList);
      // }
      const orgPromise = localStorage.getItem("setPersonOrg") ? JSON.parse(localStorage.getItem("setPersonOrg")) : this.$store.dispatch("approvePerson/getorg");
      const userPromise = localStorage.getItem("setPersonUser") ? JSON.parse(localStorage.getItem("setPersonUser")) : this.$store.dispatch("approvePerson/getuser");
      this.loading = true;
      Promise.all([orgPromise, userPromise])
        .then(([orgres, userres]) => {
          console.log("orgres", orgres);
          console.log("userres", userres);
          this.formatDataSource(orgres, userres);
        })
        .catch(e => console.log(e));
    },
    formatDataSource(orgList, userList) {
      orgList.forEach(v => {
        v.type = 2;
      });
      this.organizationList = formatTreeData(orgList, "id", "parentId", "children", "parent_id");
      if (!userList) {
        userList = [];
      }
      userList.forEach(v => {
        v.type = 1;
      });
      const newArry = userList.map(item => ({
        ...item,
        parentId: item.organizationId,
      }));
      this.userList = userList;
      /* 
        把计算缓慢的数据暂时隐藏
      */
      let storageUserList = []; //缓存的用户数据
      this.$forage.getItem("orgListData").then(val => {
        storageUserList = val;
      });
      console.log(storageUserList);
      if (storageUserList?.length > 0) {
        this.allData = storageUserList;
        this.treeArry = storageUserList;
        console.log("this.treeArry", this.treeArry);
      } else {
        let arr = formatTreeData(orgList.concat(newArry), "id", "parentId", "children", "parent_id");
        this.allData = arr;
        this.treeArry = arr;
        this.$forage.setItem("orgListData", arr).then(val => {
          console.log(val);
        });
        console.log("this.treeArry", this.treeArry);
      }
      // this.treeArry = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      // this.allData = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      this.loading = false;
    },
    delItem(i) {
      this.sallerList.splice(i, 1);
      console.log(this.sallerList);
    },
    delItem1(i) {
      console.log(i);
      this.collectClaimList.splice(i, 1);
    },
    addsallerList() {
      let arr = this.$refs["cascader"].getCheckedNodes();
      arr.forEach(e => {
        if (e.children.length == 0) {
          this.sallerList.push({ saller: e.label, sallerId: e.value });
        }
      });
      const map = new Map();
      const newList3 = this.sallerList.filter(v => !map.has(v.sallerId) && map.set(v.sallerId, 1));
      this.sallerList = newList3;
    },
    sendSrueSaller() {
      let ids = [];
      this.sallerList.forEach(e => {
        ids.push(e.sallerId);
      });
      if (this.sendFlag) {
        this.sendFlag = false;
        sendMessionSaller(ids).then(res => {
          if (res.code == 1001) {
            this.$message.success("操作成功！");
            this.dialog3 = false;
          }
        });
        setTimeout(() => {
          this.sendFlag = true;
        }, 500);
      }
    },
    userChooseChange(e) {
      console.log(e);
    },
    // setTitle(row) {
    //     console.log(row)
    //     const columnIndex = row.columnIndex
    //     if (columnIndex == 10 || columnIndex == 11 || columnIndex == 12
    //         || columnIndex == 13 || columnIndex == 14 || columnIndex == 15 || columnIndex == 16) {
    //         return "background: #fffd97;";
    //     } else {
    //         return 'background: #f3f6f9;'
    //     }
    // },
    changestatus() {
      console.log(this.formDate.billType);
    },
    initaddPayer() {
      this.addPayerUnit = this.$options.data().addPayerUnit;
    },
    addPayerUnitSure() {
      saveOrUpdate(this.addPayerUnit).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.getpayerUnitManage();
          this.initaddPayer();
          this.dialog2 = false;
        }
      });
    },
    delPayerUnit(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deletePayUnit({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.getpayerUnitManage();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    /*获取列表*/
    async gettableDataex() {
      this.tableLoading = true;
      await post(this.queryPage, this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.total = res.data.totalRows;
          this.tableData = res.data.data;
          var today = new Date();
          this.tableData.forEach(e => {
            let endDate = new Date(e.dueDate);
            e.dueDays = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
          });
          this.copyDataSource = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    /* 获取主体 */
    get_list_by_type() {
      get_list_by_type({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        if (res.code == 1001) {
          this.mainList = res.data;
        }
      });
    },
    /* 获取字典 */
    get_detail_code() {
      //
      get_detail_code({ codes: "SHOUKUANXINGSHI,CreditBank,SHOUKUANHANG4,PIAOJULEIXING,engineeringMainBody" }).then(res => {
        if (res.code == 1001) {
          console.log(res.data);
          this.shoukuanList = res.data["SHOUKUANXINGSHI"].items;
          // this.shoukuanandmonList1 = res.data['SHOUKUANHANG1'].items;
          this.shoukuanandmonList = [...res.data["CreditBank"].items];
          // this.shoukuanandmonList2 = res.data['SHOUKUANHANG4'].items;
          this.piaojuList = res.data["PIAOJULEIXING"].items;
          this.mainListBodys = res.data["engineeringMainBody"].items;
        }
      });
    },
    changePayUnit() {
      var arrChoose = this.payerUnitNoPage.filter(e => {
        if (e.id == this.formDate.payUnitId) {
          return true;
        }
      });
      this.formDate.acceptor = arrChoose[0].payerUntiName;
      this.formDate.drawerAccount = arrChoose[0].payerUntiName;
      this.formDate.endorser = arrChoose[0].payerUntiName;
      this.formDate.whetherGroup = arrChoose[0].whetherGroup;
    },
    changeCollaborat() {
      var arrChoose = this.mainList.filter(e => {
        if (e.id == this.formDate.collaborativeAgentId) {
          return true;
        }
      });
      this.formDate.payeeAccount = arrChoose[0].name;
    },
    addcardSure(formName) {
      console.log(this.formDate);
      var time = new Date(this.formDate.issueDate);
      this.formDate.issueDate = time.Format("yyyy-MM-dd");
      // if(!this.editFlag){
      //     return;
      // }
      // let data = { ...this.low, invoiceAssembleAmount: this.invoicedAmount };
      this.$refs[formName].validate(valid => {
        if (valid) {
          saveOrUpdatecollectMoney(this.formDate).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
            this.gettableDataex();
            this.dialog = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    queryInvoicedAmount(id) {
      queryInvoicedAmount({ engId: id }).then(res => {
        this.invoicedAmount = res.data;
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    addCollectClaim() {
      let item = {
        engineeringId: "", //工程id
        enginnerrName: "", //工程名
        claimMoney: 0, //认领金额
        flowPath: 0, //流程：0流程未走完；1流程已走完
        collaborationUnit: "", //合同签订主体d
        collaborationUnitId: "", //合同签订主体
        financialCode: "", //财务编码
        saller: "", //销售员
        sallerId: "", //销售员id
        sallerDivision: "", //销售处别
        sallerDivisionId: "", //销售处别id
      };
      this.collectClaimList.push(item);
    },
    addOtherCard(row) {
      console.log(row);
      this.formDate = row;
      this.renlingId = row.id;
      queryCollectClaimList({ id: row.id }).then(res => {
        if (res.code == 1001) {
          this.collectClaimList = res.data;
        }
      });
      this.dialog4 = true;
    },
    addcard() {
      this.formDate = this.$options.data().formDate;
      this.titleName = "添加";
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["formDate"].clearValidate();
      });
    },
    // 导入
    exprotCard(){

    },
    costMoneyInit() {
      this.dialog1 = true;
    },
    sallerSure() {
      // this.loadingSaller = true
      queryDefaultSallers().then(res => {
        if (res.code == 1001) {
          this.sallerList = res.data;
        }
      });
      setTimeout(() => {
        this.dialog3 = true;
        this.loadingSaller = false;
      });
    },
    lookcard(row) {
      this.titleName = "修改";
      console.log(row);
      this.formDate = this.copy(row);
      this.dialog = true;
    },
    delHandler() {
      console.log(this.ids);
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          post(this.batchUpdateOrDelete, this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    changstatus(e, row) {
      var chooseArr = this.engineeringNameList.filter(m => {
        if (m.engineeringId == row.engineeringId) {
          return true;
        }
      });

      // this.collectClaimList[e].saller = chooseArr[0].saller
      // this.collectClaimList[e].sallerDivision = chooseArr[0].sallerDivision
      this.collectClaimList[e] = { ...this.collectClaimList[e], ...chooseArr[0] };
      this.collectClaimList[e].enginnerrName = chooseArr[0].engineeringName;
      if (!chooseArr[0].financialCode) {
        this.collectClaimList[e].financialCode = "";
      } else {
        this.collectClaimList[e].financialCode = chooseArr[0].financialCode;
      }
      if (!chooseArr[0].collaborationUnit) {
        this.collectClaimList[e].collaborationUnit = "";
      } else {
        this.collectClaimList[e].collaborationUnit = chooseArr[0].collaborationUnit;
      }
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    addOtherSure() {
      console.log(this.collectClaimList);
      let data = {
        id: this.renlingId,
        collectMoneyClaimList: this.collectClaimList,
      };
      updateCollectMoneyClaim(data).then(res => {
        if (res.code == 1001) {
          this.gettableDataex();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialog4 = false;
        }
      });
    },
    chooseNav(index) {
      this.currenindex = index;
    },
    open(low, key, disabled) {
      this.low = this.copy(low);
      this.disabled = disabled;
      this[key] = true;
    },
    reset(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
      this.gettableDataex();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = { ...this.tableParam, billType: "", billNumber: "", subjectCompany: "", receiver: "", startTime: "", endTime: "", dueStartTime: "", dueEndTime: "", authBankId: "",paymentMethodId:"" };
      this.gettableDataex();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataex();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.tabtop {
  width: 381px;
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.el-select-dropdown__list {
  width: 400px;
}

.boxSaller {
  display: flex;
  flex-wrap: wrap;
}

.sallerItem {
  // width: auto;
  height: 30px;
  background: #c4f0d9;
  // color: #fff;
  text-align: center;
  line-height: 30px;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.search {
  display: flex;
  flex-wrap: wrap;
}
</style>
